import roller_yihao_settings_gen_3 from '@devices/settings/common_settings/roller_yihao_settings_gen_3.js';

export default {
	name: 'YihaoYH002A',
	friendly_name: 'Yihao YH-002A',
	bt_scan_prefix: 'YH-002A',
	family: 'roller',
	isPM: false,
	reset_from_input: true,
	modes: {
		roller: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: ['offline', 'device_problem'],
			slider: true,
			settings: roller_yihao_settings_gen_3,
		},
	},
};
